// HVAC presentation model only. Never import conditioning APIs or real device IDs here.
// On-site control (including any future API integration) is manually verified by the user.

export const AIR_PROJECT_ID = '1000107'
// 南都 10F 极派＆云脉区：唯一接入实时内机的区域（1=10F-03-04、2=05、3=06、4=07）。
export const REAL_AC_ZONE_ID = 's01'
export const AIR_MAP_SIZE = { width: 1390, height: 1132 }
export const AIR_SNAPSHOTS = ['08:00', '09:00', '10:00']
export const AIR_MODES = [
  { id: 'cool', name: '制冷', icon: 'el-icon-refrigerator' },
  { id: 'heat', name: '制热', icon: 'el-icon-sunny' },
  { id: 'dry', name: '除湿', icon: 'el-icon-water-cup' },
  { id: 'fan', name: '送风', icon: 'el-icon-wind-power' },
  { id: 'auto', name: '自动', icon: 'el-icon-refresh' }
]
export const AIR_SPEEDS = [{ id: 'auto', name: '自动' }, { id: 'low', name: '低风' }, { id: 'medium', name: '中风' }, { id: 'high', name: '高风' }]

// Room interiors traced in the original PNG coordinate system. These are display zones,
// not a claim about tenant leases or actual AC mounting coordinates. Two mock units per zone.
export const AIR_ZONES = [
  { id: 'n01', name: '北侧办公区 01', rect: [49, 48, 239, 263], temperatures: [22.5, 22.1, 21.6], states: ['run', 'standby'] },
  { id: 'n02', name: '北侧办公区 02', rect: [309, 48, 235, 263], temperatures: [24.0, 24.2, 24.4], states: ['run', 'run'] },
  { id: 'n03', name: '北侧办公区 03', rect: [562, 48, 234, 263], temperatures: [23.3, 23.5, 23.8], states: ['standby', 'run'] },
  { id: 'n04', name: '北侧办公区 04', rect: [814, 48, 242, 263], temperatures: [24.8, 25.0, 25.2], states: ['run', 'run'] },
  { id: 'n05', name: '北侧办公区 05', rect: [1077, 48, 240, 263], temperatures: [26.0, 27.1, 28.6], states: ['run', 'run'] },
  { id: 's01', name: '极派＆云脉', rect: [49, 820, 495, 250], temperatures: [25.4, 26.2, 26.8], states: ['run', 'standby', 'run', 'standby'], positions: [[0.24, 0.35], [0.24, 0.66], [0.76, 0.35], [0.76, 0.66]] },
  { id: 's02', name: '南侧办公区 02', rect: [562, 820, 234, 250], temperatures: [24.0, 24.3, 24.6], states: ['run', 'offline'] },
  { id: 's03', name: '南侧办公区 03', rect: [814, 820, 242, 250], temperatures: [23.9, 24.2, 24.5], states: ['run', 'run'] },
  { id: 's04', name: '南侧办公区 04', rect: [1077, 820, 240, 250], temperatures: [null, null, null], states: ['offline', 'standby'] }
]

export function createAirDemo () {
  return AIR_ZONES.reduce((devices, zone) => devices.concat(zone.states.map((state, index) => ({
    id: `mock-hvac-${zone.id}-${index + 1}`,
    zoneId: zone.id,
    name: `内机 ${String(index + 1).padStart(2, '0')}`,
    serial: `MOCK-10F-${zone.id.toUpperCase()}-${index + 1}`,
    online: state !== 'offline',
    power: state === 'run',
    mode: 'cool',
    speed: 'auto',
    setpoint: 25,
    simulated: true
  }))), [])
}

export function airState (device) { return !device.online ? 'offline' : device.power ? 'run' : 'standby' }
export const AIR_STATE_NAMES = { run: '运行', standby: '待机', offline: '离线' }
export function airTemperatureTone (temperature) { return temperature == null ? 'unknown' : temperature < 22 ? 'cool' : temperature > 26 ? 'warm' : 'comfortable' }

// Explicit local reducer: no transport, callbacks, timers, storage or device commands.
export function applyAirDemo (devices, command) {
  if (!command || typeof command !== 'object') return devices
  const device = devices.find(item => item.id === command.deviceId)
  const values = command.values || {}
  if (!device || !device.online || !device.simulated || !device.id.startsWith('mock-hvac-')) return devices
  if (typeof values.power !== 'boolean' || !AIR_MODES.some(mode => mode.id === values.mode) || !AIR_SPEEDS.some(speed => speed.id === values.speed)) return devices
  if (!Number.isInteger(values.setpoint) || values.setpoint < 16 || values.setpoint > 30) return devices
  return devices.map(item => item.id === device.id ? { ...item, power: values.power, mode: values.mode, speed: values.speed, setpoint: values.setpoint } : item)
}

export function airZoneIssues (devices, snapshot, zoneTemperatures = {}) {
  const issues = []
  AIR_ZONES.forEach(zone => {
    const override = zoneTemperatures ? zoneTemperatures[zone.id] : null
    const temperature = override != null ? override : zone.temperatures[snapshot]
    const tone = airTemperatureTone(temperature)
    if (tone === 'warm' || tone === 'cool') issues.push({ id: `${zone.id}-temperature`, zoneId: zone.id, name: zone.name, title: tone === 'warm' ? '室温偏高' : '室温偏低', detail: `${temperature.toFixed(1)}°C · ${override != null ? '实时室温' : '演示参考区间 22–26°C'}`, tone: tone === 'warm' ? 'warm' : 'cool', icon: 'el-icon-odometer' })
    devices.filter(device => device.zoneId === zone.id && !device.online).forEach(device => issues.push({ id: device.id, zoneId: zone.id, name: zone.name, title: `${device.name}离线`, detail: '通信状态未知 · 建议核查采集链路', tone: 'offline', icon: 'el-icon-connection' }))
  })
  return issues
}
